module.exports = __webpack_public_path__ + "img/line_icon.37b0675d.png";